import Component from "@base/js/component";
import MultiSelect from "@components/multi-select/multi-select";

export default class SearchFilter extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".search-filter";

  isCollapsed = false;

  mutationObserver = new MutationObserver(this.onMutate.bind(this));

  // Defines children that needs to be queried as part of this component
  static children = {
    dropdownToggler: ".search-filter__dropdown-toggler", // Queries a single element
    group: ".search-filter-group", // Queries a single element
    groupContent: ".search-filter-group__content", // Queries a single element
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    dropdownToggler: {
      click: this.toggleFilters,
    },
  };

  // Will be called upon component instantiation
  afterInit() {
    this.mutationObserver.observe(this.element, {
      childList: true,
      subtree: true,
    });

    this.setupDrawersBeforeExpand();
  }

  afterUncollapsed = () => {
    const { group } = this.children;

    group.style.overflow = "unset";
    group.style.maxHeight = "unset";

    group.removeEventListener("transitionend", this.afterUncollapsed);
  };

  toggleFilters() {
    const { group, groupContent, dropdownToggler } = this.children;
    const toggleIcon = dropdownToggler.querySelector(".icon--caret-down-thick");

    if (this.isCollapsed) {
      group.style.maxHeight = `${group.scrollHeight}px`;

      setTimeout(() => {
        group.style.maxHeight = 0;
        group.style.overflow = "hidden";
      }, 0);

      toggleIcon.style.transform = ``;
    } else {
      group.style.maxHeight = `${groupContent.offsetHeight}px`;
      group.addEventListener("transitionend", this.afterUncollapsed);

      toggleIcon.style.transform = `rotate(180deg)`;
    }

    this.isCollapsed = !this.isCollapsed;
  }

  onMutate() {
    MultiSelect.init();

    this.setupDrawersBeforeExpand();
  }

  setupDrawersBeforeExpand() {
    const multiSelectInstances = MultiSelect.getInstances();

    multiSelectInstances.forEach((multiSelectInstance) => {
      const [drawerInstance] = multiSelectInstance.members.drawer;

      if (drawerInstance) {
        const drawerCallbacks = drawerInstance.callbacks.beforeExpand;

        // Check if the callback was already added
        // to prevent duplicates.
        if (drawerCallbacks.length) {
          return;
        }

        // Collapsed the previously expanded Drawers before opening one.
        drawerInstance.beforeExpand(() => {
          multiSelectInstances
            .map((multiSelect) => multiSelect.members.drawer[0])
            .forEach((item) => {
              if (item && item.isExpanded) {
                item.toggleExpanded(false);
              }
            });
        });
      }
    });
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
SearchFilter.init();
